import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(name, email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Account created");
      nav("/app/company-setup");
    } else {
      toast.error(r.error || "Registration failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-8">
      <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="register-form">
        <div>
          <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Create account</div>
          <h1 className="font-display font-extrabold text-3xl tracking-tight mt-1">Start free trial</h1>
        </div>
        <div>
          <label className="lb-label">Full name</label>
          <input className="lb-input" value={name} onChange={(e) => setName(e.target.value)}
                 data-testid="reg-name" required />
        </div>
        <div>
          <label className="lb-label">Email</label>
          <input type="email" className="lb-input" value={email} onChange={(e) => setEmail(e.target.value)}
                 data-testid="reg-email" required />
        </div>
        <div>
          <label className="lb-label">Password</label>
          <input type="password" className="lb-input" value={password} onChange={(e) => setPassword(e.target.value)}
                 data-testid="reg-password" required minLength={6} />
        </div>
        <button type="submit" disabled={loading} className="lb-btn w-full" data-testid="reg-submit">
          {loading ? "Creating…" : "Create account →"}
        </button>
        <div className="text-sm text-neutral-500">
          Have an account?{" "}
          <Link to="/login" className="underline text-[#0A66C2] font-semibold" data-testid="link-login">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
